import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// 全部样式表
import './assets/css/global.less'

import 'amfe-flexible'

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
